export class CollateralAgreementDisbursement {
    documentNumber: string;
    collateralAgreementNumber: string;
    amount: string | number;
    quantity: number;
    date: string | Date;
    currency: {
        currencyCode: string,
        defaultFractionDigits: number,
        numericCode: number,
        displayName: string,
        symbol: string,
        numericCodeAsString: string
    };
    description: string;
    initiatedUserId: string;
    channelCode: string;
    branchId: string;
    customerSpecificOptions: [
        {
            customerId: string;
        }
    ];
    purpose: string;
}